// ─────────────────────────────────────────────────────────────
// Source unique des projets / réalisations ML.
// Utilisée par la section "Projets" de la home ET la page /portfolio.
// Les maquettes servies en iframe pointent vers /public/mockups/.
// ─────────────────────────────────────────────────────────────

export const SECTEURS = [
  { id: "tous", label: "Tous" },
  { id: "restauration", label: "Restauration" },
  { id: "beaute", label: "Beauté & Bien-être" },
  { id: "artisans", label: "Artisans & Services" },
  { id: "proximite", label: "Commerces de proximité" },
];

export const projects = [
  // ===== EN VEDETTE =====
  {
    id: "car-wash",
    title: "Car Wash",
    type: "Lavage auto / Detailing",
    secteur: "proximite",
    route: "/projets/car-wash",
    image:
      "https://images.unsplash.com/photo-1607860108855-64acf2078ed9?w=1280&h=900&fit=crop&q=80",
    tags: ["Site immersif", "Réservation", "Animations 3D"],
    label: "Concept ML Agence",
    year: "2026",
    featured: true,
    home: true,
    span: "lg:col-span-7",
    aspect: "aspect-[4/3]",
  },
  {
    id: "cake",
    title: "Cake",
    type: "Pâtisserie artisanale",
    secteur: "restauration",
    route: "/projets/cake",
    image:
      "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=1280&h=900&fit=crop&q=80",
    tags: ["Site vitrine", "Commande en ligne", "DA gourmande"],
    label: "Concept ML Agence",
    year: "2026",
    featured: true,
    home: true,
    span: "lg:col-span-5",
    aspect: "aspect-[4/5]",
  },

  // ===== AUTRES RÉALISATIONS =====
  {
    id: "nail-studio",
    title: "Nail Studio",
    type: "Beauté / Onglerie",
    secteur: "beaute",
    route: "/projets/nail-studio",
    image:
      "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=1280&h=900&fit=crop&q=80",
    tags: ["Manucure russe", "Book visuel", "Réservation"],
    label: "Concept ML Agence",
    year: "2026",
    home: true,
    span: "lg:col-span-5",
    aspect: "aspect-[4/5]",
  },
  {
    id: "bien-etre",
    title: "Studio Bien-Être",
    type: "Bien-être / Massages",
    secteur: "beaute",
    route: "/projets/bien-etre",
    image:
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=1280&h=900&fit=crop&q=80",
    tags: ["Soins holistiques", "Prise de RDV", "DA apaisante"],
    label: "Concept ML Agence",
    year: "2026",
    home: true,
    span: "lg:col-span-7",
    aspect: "aspect-[4/3]",
  },
  {
    id: "bella-napoli",
    title: "Bella Napoli",
    type: "Restauration / Pizzeria",
    secteur: "restauration",
    route: "/projets/bella-napoli",
    image:
      "https://images.pexels.com/photos/35760009/pexels-photo-35760009.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1280",
    tags: ["Site Vitrine", "Réservation", "Menu interactif"],
    label: "Concept ML Agence",
    year: "2024",
  },
  {
    id: "salon-cote",
    title: "Salon Côté",
    type: "Beauté / Coiffure",
    secteur: "beaute",
    route: "/projets/salon-cote",
    image:
      "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1280&h=900&fit=crop&q=80",
    tags: ["Réservation en ligne", "UX Premium"],
    label: "Concept ML Agence",
    year: "2024",
  },
  {
    id: "depann-eau-pro",
    title: "Dépann'Eau Pro",
    type: "Artisanat / Plomberie",
    secteur: "artisans",
    route: "/projets/depann-eau-pro",
    image:
      "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1280",
    tags: ["SEO Local", "Mobile-first", "Urgences 24/7"],
    label: "Concept ML Agence",
    year: "2025",
  },
  {
    id: "barbier",
    title: "Maison du Barbier",
    type: "Barbershop / Proximité",
    secteur: "proximite",
    route: "/projets/barbier",
    image:
      "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=1280&h=900&fit=crop&q=80",
    tags: ["Ambiance immersive", "Réservation", "SEO Local"],
    label: "Concept ML Agence",
    year: "2026",
  },
];

export const homeProjects = projects.filter((p) => p.home);
